import operator from './operator'
import admin from './admin'
import contractor from './contractor'
import shared from './shared'

// Array of sections
export default [...shared, ...operator, ...admin, ...contractor]
